import React from "react";
import { CircleCheckIcon, LockIcon, MailIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { heroChips, mockupImage } from "../data/content";
const trust = [{
  icon: LockIcon,
  label: "Paiement sécurisé"
}, {
  icon: MailIcon,
  label: "Livraison par e-mail"
}, {
  icon: ShieldCheckIcon,
  label: "Garantie 10 jours"
}];
export function Hero() {
  return <section className="bg-ink px-4 pb-14 pt-8 sm:px-6 sm:pb-20 sm:pt-16" data-id="element-79" data-mp="129qtzk94hnnc">
      <div className="mx-auto grid max-w-6xl items-center gap-8 lg:grid-cols-[1.05fr_1fr] lg:gap-12" data-id="element-80" data-mp="xae6cxafgcjp">
        <div className="text-center lg:text-left" data-id="element-81" data-mp="sb1ajn1kvv4z">
          <p className="inline-flex items-center gap-2 rounded-full border border-golddark bg-gold/5 px-4 py-2 text-[10px] font-semibold tracking-[0.18em] text-gold sm:text-xs" data-id="element-82" data-mp="s9q8brns6vfz">
            <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden data-id="element-83" data-mp="3d2l8r9xwn0zn" />
            LA MÉTHODE POUR PROFESSEURS DE GUITARE
          </p>
          <h1 className="mt-5 font-display text-[44px] font-bold uppercase leading-[0.92] text-white sm:text-7xl lg:text-[76px]" data-id="element-84" data-mp="384jpop0hb1o6">
            Votre prochain cours de guitare, <span className="text-gold" data-id="element-85" data-mp="3o6aq9wsnq90h">prêt en 5 minutes.</span>
          </h1>

          <figure className="mx-auto mt-7 max-w-xl lg:hidden" data-id="element-86" data-mp="39b4gcyqfxq1v">
            <img src={mockupImage} alt="Le pack Le Maître de la Guitare : 2 livres et 5 bonus" className="w-full rounded-2xl" data-id="element-87" data-mp="39cpfl1np9x62" />
          </figure>

          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg lg:mx-0" data-id="element-88" data-mp="30gzuktq5z4t7">
            LE MAÎTRE DE LA GUITARE™ réunit 2 livres complémentaires et 5 bonus en PDF : un guide théorique pour préparer vos explications, un livre pratique pour faire travailler vos élèves, et des ressources prêtes à imprimer.
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-89" data-mp="2vglq1lnruczx">
            {heroChips.map(c => <li key={c} className="flex items-center gap-1.5 text-sm font-semibold text-white" data-id="element-90" data-mp="2ll0g91cgo8fm">
                <CircleCheckIcon className="h-4 w-4 text-gold" aria-hidden data-id="element-91" data-mp="s2b7hx6yyh4m" />
                {c}
              </li>)}
          </ul>

          <CtaButton label="Je veux Le Maître de la Guitare™" action="offer" className="mt-8 w-full sm:w-auto" data-id="element-92" data-mp="na060pwkyn9y" />

          <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-93" data-mp="i9vpizvo9sjq">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-xs text-white/60 sm:text-sm" data-id="element-94" data-mp="1azumdhg3ytyy">
                <Icon className="h-4 w-4 text-gold" aria-hidden data-id="element-95" data-mp="162uc0uc87521" />
                {label}
              </li>)}
          </ul>
        </div>

        <figure className="hidden text-center lg:block" data-id="element-96" data-mp="x14o3yhjyo90">
          <img src={mockupImage} alt="Le pack Le Maître de la Guitare : 2 livres et 5 bonus" className="w-full rounded-2xl" data-id="element-97" data-mp="x0cu2s3lsyku" />
          <figcaption className="mt-5 inline-block border border-golddark bg-forest px-4 py-2 text-xs font-bold tracking-[0.15em] text-gold" data-id="element-98" data-mp="3lquftrppid6n">
            VOS COURS, PRÊTS À ENSEIGNER
          </figcaption>
        </figure>
      </div>
    </section>;
}